import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";

const DeleteUserRequest = async (ID) => {
  try {
    const RequestDocument = doc(db, "Requests", ID);

    await updateDoc(RequestDocument, {
      IsDeleted: true,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteUserRequest;
